import React from 'react';
import '../grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const ModalsobligationExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Modals: Obligation, Permission, and Ability</h2>

      <p>
        Modal verbs like <strong>can, must, should</strong>, and others help us express ability, permission, advice, and different levels of obligation. Their meaning depends on both the verb and the context.
      </p>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaLightbulb /> Ability & Permission</h3>
          <ul>
            <li><strong>Can</strong> = ability, permission, possibility<br /><em>I can help. You can go.</em></li>
            <li><strong>Be able to</strong> = ability (used in different tenses)<br /><em>I was able to finish on time. We will be able to join.</em></li>
            <li><strong>Can't</strong> = prohibition, inability<br /><em>You can't enter. I can't fix it.</em></li>
            <li><strong>Could</strong> = past ability, polite request, suggestion<br /><em>I could swim. Could you help?</em></li>
            <li><strong>May/Might</strong> = formal/weaker possibility<br /><em>It may/might rain.</em></li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Advice & Obligation</h3>
          <ul>
            <li><strong>Should/Ought to</strong> = advice, mild obligation<br /><em>You should save. We ought to test.</em></li>
            <li><strong>Must/Have to</strong> = strong obligation<br /><em>You must follow rules. I have to leave.</em></li>
            <li><strong>Mustn't</strong> = prohibition<br /><em>You mustn't touch that.</em></li>
            <li><strong>Don't have to</strong> = no obligation<br /><em>You don't have to stay.</em></li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Necessity & Formal Requirements</h3>
          <ul>
            <li><strong>Need to</strong> = necessity<br /><em>You need to update.</em></li>
            <li><strong>To be + mandatory</strong> = required by rule/law<br /><em>It is mandatory.</em></li>
            <li><strong>Obligatory/Required</strong> = formal necessity<br /><em>Reports are required.</em></li>
            <li><strong>Compulsory/Necessary/Essential</strong> = importance level<br /><em>Attendance is essential.</em></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModalsobligationExplanation;
